export default "__VITE_ASSET__38938ba9__"